import * as React from 'react';
import { StickyCallToAction } from '@grandvisionhq/common';
import { StickyPriceView } from '../../../../StickyCta/components/StickyPriceView.js';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { useFramesEcommContext } from '../../context/FramesEcommContext.js';
import { useFramesPriceFrom } from '../../hooks/use-frames-price-from.js';
import { FramesCTA } from '../FramesCTA/FramesCTA.js';

const FramesStickyCTA = ({ className  })=>{
    const { displayPrice  } = useFramesEcommContext();
    const { fromPricePrefix  } = useFramesPriceFrom();
    return /*#__PURE__*/ React.createElement(StickyCallToAction, {
        className: className,
        button: /*#__PURE__*/ React.createElement(FramesCTA, null),
        price: /*#__PURE__*/ React.createElement(StickyPriceView, {
            displayPrice: displayPrice,
            prefix: fromPricePrefix
        })
    });
};

export { FramesStickyCTA };
//# sourceMappingURL=FramesStickyCTA.js.map
